import { Centrifuge, Subscription } from 'centrifuge'
import {
  getUnreadNotifications,
  getUserNotificationConfirmationMessage,
  getUserNotificationsChannel,
} from 'components/UserNotifications/hooks/utils'
import { userNotificationsSchema, UserNotification } from 'components/UserNotifications/schemas/schema'
import { WebSocketEngine } from 'containers/WebSocketProvider/engines/WebSocketEngine'
import { initializeSubscription } from 'containers/WebSocketProvider/hooks/utils'

import { FreeRoundNotificationHandler } from './Handlers/FreeRoundNotificationHandler'
import { PaymentNotificationHandler } from './Handlers/PaymentNotificationHandler'
import { getWebSocketAuthorizationData } from 'Game/Tournaments/Model/utils'
import user from 'Models/UserModel'

export class UserNotifications {
  private webSocketInstance?: Centrifuge
  private subscription?: Subscription
  private userId: string

  constructor() {
    this.userId = user.config.id
    this.initializeSubscription()
  }

  private async initializeSubscription() {
    if (this.webSocketInstance || this.subscription) {
      return
    }

    this.webSocketInstance = await WebSocketEngine.getWebSocketEngine(getWebSocketAuthorizationData)
    this.subscription = initializeSubscription({
      webSocketInstance: this.webSocketInstance,
      channel: this.getUserNotificationsChannel(),
      onPublication: (data) => this.onPublication(data),
      multi: true,
    })
  }

  private getUserNotificationsChannel() {
    return getUserNotificationsChannel(this.userId)
  }

  private onPublication(data: unknown) {
    const notifications = userNotificationsSchema.parse(data)
    const unreadNotifications = getUnreadNotifications(notifications)

    this.handleNotification(unreadNotifications[unreadNotifications.length - 1])
  }

  private handleNotification(notification: UserNotification) {
    switch (notification.type) {
      case 'payment':
        return new PaymentNotificationHandler().render(notification.payload, () =>
          this.confirmNotification(notification),
        )

      case 'freeRound':
        return new FreeRoundNotificationHandler().render(notification.payload, () =>
          this.confirmNotification(notification),
        )

      default:
        return null
    }
  }

  private confirmNotification(notification: UserNotification) {
    if (!this.subscription) {
      return
    }

    this.subscription.publish(getUserNotificationConfirmationMessage(notification))
  }
}
